module.exports = __webpack_public_path__ + "img/email-icon.655f9645.svg";